// Percent in Indonesian notation: decimal comma, at most two decimals (12,5%).
export default function formatPercent(value) {
  return `${Number(value || 0).toLocaleString("id-ID", { maximumFractionDigits: 2 })}%`;
}
